import { render, staticRenderFns } from "./PasswordResetView.vue?vue&type=template&id=7d78ab08&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordResetView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordResetView.vue?vue&type=style&index=0&id=7d78ab08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d78ab08",
  null
  
)

export default component.exports